/**
 * @generated SignedSource<<8ad9eb917e9420b6662f1786a43d03ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProfileNotificationsPage_viewer$data = {
  readonly projectOwner: boolean | null;
  readonly disableNotifications: boolean | null;
  readonly company: {
    readonly forecastDemo: boolean | null;
    readonly tier: TierType | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"profileNotificationsSettings_viewer" | "ProfileProjectStatusUpdates_viewer" | "SettingsProfileSubNav_viewer">;
  readonly " $fragmentType": "ProfileNotificationsPage_viewer";
};
export type ProfileNotificationsPage_viewer$key = {
  readonly " $data"?: ProfileNotificationsPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileNotificationsPage_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileNotificationsPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastDemo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "profileNotificationsSettings_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileProjectStatusUpdates_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SettingsProfileSubNav_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "75c2ba418602156e5cf047e975b1e0b8";

export default node;
